import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {QueryProvider} from '@shared/queries/query-provider';
import {CreateFilingCommand} from "../../commands/dac6-reporter.command";
import {TimeZoneService} from "@core/services/time-zone.service";

@Component({
    standalone: false,
    selector: 'particle-create-filing-mx-dialog',
  templateUrl: './create-filing-mx-dialog.component.html',
  styleUrls: ['./create-filing-mx-dialog.component.scss']
})
export class CreateFilingMexicoDialogComponent implements OnInit, OnDestroy, IDialogView  {
  data: DialogModel;
  private unsubscribe$ = new Subject<void>();
  constructor() {
  }

  ngOnInit() {
    this.data.isDisabledOkButton = false;
  }
  onOkClicked(): boolean {
    this.data.input['cancelFiling'] = true;
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
